import { sb } from '../../supabase.ts';
import { escapeHtml } from '../../main.ts';
import { IMGBB_API_KEY } from '../../config.ts';

export async function renderOtherSchoolAdmissionPage(app: HTMLElement): Promise<void> {
  const TABLE = 'student_database_others';

  app.innerHTML = `
    <style>
      @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800;900&family=Hind+Siliguri:wght@400;500;600;700&display=swap');

      .admission-wrap {
        font-family: 'Outfit', 'Hind Siliguri', sans-serif;
        background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.05), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        min-height: 100vh;
        color: #334155;
        padding-bottom: 60px;
        position: relative;
        box-sizing: border-box;
      }

      .sticky-header {
        position: sticky;
        top: 0;
        background: rgba(255, 255, 255, 0.9);
        backdrop-filter: blur(25px);
        -webkit-backdrop-filter: blur(25px);
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        z-index: 100;
        padding: 12px 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .back-btn {
        color: #10b981;
        text-decoration: none;
        font-weight: 700;
        font-size: 14px;
        display: flex;
        align-items: center;
        gap: 6px;
        transition: transform 0.2s;
        background: none;
        border: none;
        cursor: pointer;
      }

      .back-btn:hover {
        transform: translateX(-4px);
      }

      .container-premium {
        max-width: 1000px;
        margin: 24px auto;
        padding: 0 20px;
        box-sizing: border-box;
      }

      .alert-box-premium {
        display: none;
        padding: 14px 20px;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 20px;
        text-align: center;
      }

      .alert-box-premium.success {
        display: block;
        background: rgba(16, 185, 129, 0.15);
        color: #10b981;
        border: 1px solid rgba(16, 185, 129, 0.3);
      }

      .alert-box-premium.error {
        display: block;
        background: rgba(239, 68, 68, 0.15);
        color: #f87171;
        border: 1px solid rgba(239, 68, 68, 0.3);
      }

      .search-box-premium {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.05);
        border-radius: 16px;
        padding: 20px;
        backdrop-filter: blur(12px);
        margin-bottom: 24px;
        display: flex;
        gap: 12px;
        align-items: center;
      }

      .search-box-premium input {
        flex: 1;
        padding: 10px 16px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        color: #0f172a;
        font-size: 14px;
        outline: none;
      }

      .search-box-premium button {
        padding: 10px 20px;
        background: #10b981;
        border: none;
        border-radius: 8px;
        color: #fff; font-weight: 700; cursor: pointer;
        transition: opacity 0.2s;
      }

      .search-box-premium button:hover {
        opacity: 0.9;
      }

      .bento-grid {
        display: flex;
        flex-direction: column;
        gap: 20px;
      }

      .card-premium {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.05);
        border-radius: 18px;
        padding: 24px;
        backdrop-filter: blur(16px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
      }

      .card-title {
        font-size: 16px;
        font-weight: 800;
        color: #0f172a;
        margin-top: 0;
        margin-bottom: 18px;
        display: flex;
        align-items: center;
        gap: 8px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.05);
        padding-bottom: 10px;
      }

      .card-title span.bn {
        font-size: 13px;
        font-weight: 500;
        color: #64748b;
      }

      .grid-3 {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
        gap: 16px;
      }

      .field-group {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }

      .field-group label {
        font-size: 11px;
        font-weight: 700;
        color: #64748b;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        display: flex;
        justify-content: space-between;
      }

      .field-group label span.bn {
        text-transform: none;
        font-family: 'Hind Siliguri', sans-serif;
        color: #10b981;
      }

      .input-premium {
        padding: 10px 14px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        color: #0f172a;
        font-size: 13.5px;
        outline: none;
        box-sizing: border-box;
        width: 100%;
        transition: border-color 0.2s, box-shadow 0.2s;
      }

      .input-premium:focus {
        border-color: #10b981;
        box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.15);
      }

      .input-premium.invalid {
        border-color: #f87171;
        box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
      }

      select.input-premium {
        cursor: pointer;
        appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%238b949e'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 12px center;
        background-size: 14px;
        padding-right: 32px;
      }

      .upload-wrap {
        display: flex;
        gap: 12px;
        align-items: center;
      }

      .photo-placeholder-premium {
        width: 90px;
        height: 110px;
        border: 2px dashed rgba(0, 0, 0, 0.15);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        color: #64748b;
        cursor: pointer;
        transition: border-color 0.2s;
      }

      .photo-placeholder-premium:hover {
        border-color: #10b981;
        color: #0f172a;
      }

      .photo-preview-premium {
        width: 90px;
        height: 110px;
        object-fit: cover;
        border-radius: 10px;
        border: 2px solid #10b981;
        display: none;
      }

      .btn-upload-trigger {
        padding: 8px 14px;
        background: rgba(0, 0, 0, 0.05);
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        color: #0f172a;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        transition: background 0.2s;
      }

      .btn-upload-trigger:hover {
        background: rgba(0, 0, 0, 0.15);
      }

      .btn-upload-trigger.uploaded {
        background: rgba(16, 185, 129, 0.15);
        border-color: #10b981;
        color: #10b981;
      }

      .footer-actions {
        display: flex;
        justify-content: flex-end;
        gap: 16px;
        margin-top: 24px;
      }

      .btn-action {
        padding: 12px 28px;
        border-radius: 10px;
        font-size: 14.5px;
        font-weight: 850;
        cursor: pointer;
        transition: transform 0.2s, opacity 0.2s;
        border: none;
      }

      .btn-action:hover {
        transform: translateY(-1.5px);
      }

      .btn-action.primary {
        background: linear-gradient(135deg, #10b981, #059669);
        color: #0f172a;
        box-shadow: 0 6px 20px rgba(16, 185, 129, 0.2);
      }

      .btn-action.secondary {
        background: transparent;
        border: 1px solid rgba(0, 0, 0, 0.15);
        color: #334155;
      }

      .btn-action.secondary:hover {
        background: rgba(255, 255, 255, 0.05);
      }

      /* Crop Modal Premium Style */
      .crop-modal-premium {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.75);
        backdrop-filter: blur(8px);
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease;
        z-index: 10000;
      }

      .crop-modal-premium.active {
        opacity: 1;
        pointer-events: auto;
      }

      .crop-card-premium {
        background: #f1f5f9;
        border: 1px solid rgba(0, 0, 0, 0.1);
        border-radius: 18px;
        padding: 24px;
        width: 90%;
        max-width: 650px;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
      }

      .crop-canvas-premium {
        width: 100%;
        max-height: 400px;
        background: #000;
        border-radius: 8px;
        cursor: crosshair;
        display: block;
        margin: 0 auto 16px;
      }

      .crop-actions-premium {
        display: flex;
        justify-content: flex-end;
        gap: 12px;
      }

      .crop-btn-premium {
        padding: 8px 18px;
        border-radius: 8px;
        font-weight: 700;
        font-size: 13px;
        cursor: pointer;
        border: none;
      }

      .crop-btn-premium.confirm {
        background: #10b981;
        color: #0f172a;
      }

      .crop-btn-premium.cancel {
        background: #374151;
        color: #334155;
      }
    </style>

    <div class="admission-wrap">
      <div class="sticky-header">
        <button class="back-btn" id="backBtn">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5"><path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" /></svg>
          Back to Dashboard
        </button>
        <h1 style="font-size: 18px; font-weight: 850; color: #0f172a; margin: 0;">New External Admission Form</h1>
        <div style="font-size: 12px; color: #64748b; font-weight: 600;">Other School Hub</div>
      </div>

      <div class="container-premium">
        <!-- Alert Box -->
        <div id="alertBox" class="alert-box-premium"></div>

        <!-- Search portal to look up application receipt -->
        <div class="search-box-premium">
          <input type="text" id="searchBirthReg" placeholder="Enter Birth Registration Number to find admission receipt..." />
          <button id="searchBtn">Find Receipt</button>
        </div>

        <form id="admissionForm" class="bento-grid" onsubmit="return false;">
          <!-- Section 1: Admission Scope -->
          <div class="card-premium">
            <h2 class="card-title">
              🏢 Admission Scope <span class="bn">ভর্তি সুযোগ</span>
            </h2>
            <div class="grid-3">
              <div class="field-group">
                <label>Session <span class="bn">সেশন</span></label>
                <select id="session" class="input-premium" required>
                  <option value="${new Date().getFullYear()}">${new Date().getFullYear()}</option>
                  <option value="${new Date().getFullYear() + 1}">${new Date().getFullYear() + 1}</option>
                </select>
              </div>

              <div class="field-group">
                <label>Admission Class <span class="bn">ভর্তির শ্রেণি</span></label>
                <select id="class_2026" class="input-premium" required>
                  <option value="">--Select--</option>
                  <option value="6">Class Six (৬ষ্ঠ)</option>
                  <option value="7">Class Seven (৭ম)</option>
                  <option value="8">Class Eight (৮ম)</option>
                  <option value="9">Class Nine (৯ম)</option>
                  <option value="10">Class Ten (১০ম)</option>
                </select>
              </div>

              <div class="field-group">
                <label>Admission Section <span class="bn">ভর্তির শাখা</span></label>
                <select id="section_2026" class="input-premium" required>
                  <option value="">--Select--</option>
                  <option value="DAY">Day (দিবা)</option>
                  <option value="MORNING">Morning (প্রভাতি)</option>
                </select>
              </div>

              <div class="field-group">
                <label>Class Roll <span class="bn">রোল</span></label>
                <input type="number" id="roll_2026" class="input-premium" placeholder="Enter Roll" required />
              </div>

              <div class="field-group">
                <label>Admission Date <span class="bn">ভর্তির তারিখ</span></label>
                <input type="date" id="admission_date" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Group <span class="bn">বিভাগ</span></label>
                <select id="group" class="input-premium" required>
                  <option value="GENERAL">General (সাধারণ)</option>
                  <option value="SCIENCE">Science (বিজ্ঞান)</option>
                  <option value="HUMANITIES">Humanities (মানবিক)</option>
                  <option value="BUSINESS STUDIES">Business Studies (ব্যবসায় শিক্ষা)</option>
                </select>
              </div>

              <div class="field-group">
                <label>Optional Subject <span class="bn">ঐচ্ছিক বিষয়</span></label>
                <input type="text" id="optional_subject" class="input-premium" placeholder="Optional subject (e.g. Higher Math)" />
              </div>

              <div class="field-group">
                <label>School Name (Others) <span class="bn">বিদ্যালয়ের নাম (অন্যান্য)</span></label>
                <input type="text" id="school_name_others" class="input-premium" placeholder="Enter school name" required />
              </div>
            </div>
          </div>

          <!-- Section 2: Student Details -->
          <div class="card-premium">
            <h2 class="card-title">
              👤 Student Information <span class="bn">শিক্ষার্থীর তথ্য</span>
            </h2>
            <div class="grid-3">
              <div class="field-group">
                <label>Student Name (English) <span class="bn">ইংরেজি নাম</span></label>
                <input type="text" id="student_name_en" class="input-premium" placeholder="Title Case only" required />
              </div>

              <div class="field-group">
                <label>Student Name (Bangla) <span class="bn">বাংলা নাম</span></label>
                <input type="text" id="student_name_bn" class="input-premium" placeholder="বাংলা নাম লিখুন" required />
              </div>

              <div class="field-group">
                <label>Birth Registration <span class="bn">জন্ম নিবন্ধন নম্বর</span></label>
                <input type="text" id="birth_registration" class="input-premium" placeholder="17-digit number" required />
              </div>

              <div class="field-group">
                <label>Date of Birth <span class="bn">জন্ম তারিখ</span></label>
                <input type="date" id="student_dateofbirth" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Religion <span class="bn">ধর্ম</span></label>
                <select id="religion" class="input-premium" required>
                  <option value="ISLAM">ISLAM</option>
                  <option value="HINDU">HINDU</option>
                  <option value="BUDDHA">BUDDHA</option>
                  <option value="CHRISTIAN">CHRISTIAN</option>
                  <option value="OTHERS">OTHERS</option>
                </select>
              </div>

              <div class="field-group">
                <label>Gender <span class="bn">লিঙ্গ</span></label>
                <select id="student_gender" class="input-premium" required>
                  <option value="MALE">MALE</option>
                  <option value="FEMALE">FEMALE</option>
                </select>
              </div>

              <div class="field-group">
                <label>Blood Group <span class="bn">রক্তের গ্রুপ</span></label>
                <select id="student_blood_group" class="input-premium" required>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                </select>
              </div>

              <!-- Photo Upload Component -->
              <div class="field-group">
                <label>Student Photo <span class="bn">ছবি (944x1181)</span></label>
                <div class="upload-wrap">
                  <div id="photoPlaceholder" class="photo-placeholder-premium">
                    <span style="font-size: 20px;">📷</span>
                    <span>Upload Image</span>
                  </div>
                  <img id="studentPhotoPreview" class="photo-preview-premium" alt="Student photo preview" />
                  <button type="button" id="uploadPhotoBtn" class="btn-upload-trigger">Choose File</button>
                  <input type="file" id="student_photo_file" style="display:none;" accept="image/*" />
                  <input type="hidden" id="student_photo_url" required />
                </div>
              </div>
            </div>
          </div>

          <!-- Section 3: Father Details -->
          <div class="card-premium">
            <h2 class="card-title">
              👨 Father Details <span class="bn">পিতার বিবরণ</span>
            </h2>
            <div class="grid-3">
              <div class="field-group">
                <label>Father Name (English) <span class="bn">ইংরেজি নাম</span></label>
                <input type="text" id="father_name_en" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Father Name (Bangla) <span class="bn">বাংলা নাম</span></label>
                <input type="text" id="father_name_bn" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Father NID <span class="bn">এনআইডি নম্বর</span></label>
                <input type="text" id="father_nid" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Father Mobile <span class="bn">মোবাইল নম্বর</span></label>
                <input type="text" id="father_mobile" class="input-premium" placeholder="8801xxxxxxxxx" required />
              </div>

              <div class="field-group">
                <label>Father Occupation <span class="bn">পেশা</span></label>
                <input type="text" id="father_occupation" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Father DOB <span class="bn">জন্ম তারিখ</span></label>
                <input type="date" id="father_dob" class="input-premium" />
              </div>

              <div class="field-group">
                <label>Father Blood Group <span class="bn">রক্তের গ্রুপ</span></label>
                <select id="father_blood_group" class="input-premium">
                  <option value="">--Select--</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Section 4: Mother Details -->
          <div class="card-premium">
            <h2 class="card-title">
              👩 Mother Details <span class="bn">মাতার বিবরণ</span>
            </h2>
            <div class="grid-3">
              <div class="field-group">
                <label>Mother Name (English) <span class="bn">ইংরেজি নাম</span></label>
                <input type="text" id="mother_name_en" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Mother Name (Bangla) <span class="bn">বাংলা নাম</span></label>
                <input type="text" id="mother_name_bn" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Mother NID <span class="bn">এনআইডি নম্বর</span></label>
                <input type="text" id="mother_nid" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Mother Mobile <span class="bn">মোবাইল নম্বর</span></label>
                <input type="text" id="mother_mobile" class="input-premium" placeholder="8801xxxxxxxxx" required />
              </div>

              <div class="field-group">
                <label>Mother Occupation <span class="bn">পেশা</span></label>
                <input type="text" id="mother_occupation" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Mother DOB <span class="bn">জন্ম তারিখ</span></label>
                <input type="date" id="mother_dob" class="input-premium" />
              </div>

              <div class="field-group">
                <label>Mother Blood Group <span class="bn">রক্তের গ্রুপ</span></label>
                <select id="mother_blood_group" class="input-premium">
                  <option value="">--Select--</option>
                  <option value="A+">A+</option>
                  <option value="A-">A-</option>
                  <option value="B+">B+</option>
                  <option value="B-">B-</option>
                  <option value="O+">O+</option>
                  <option value="O-">O-</option>
                  <option value="AB+">AB+</option>
                  <option value="AB-">AB-</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Section 5: Guardian Details -->
          <div class="card-premium">
            <h2 class="card-title">
              👥 Guardian Details <span class="bn">অভিভাবকের বিবরণ</span>
            </h2>
            <div style="margin-bottom: 16px; display: flex; gap: 20px;">
              <label style="cursor: pointer; display: flex; align-items: center; gap: 6px;">
                <input type="checkbox" id="guardian_from_father" /> Copy Father's Info (পিতা থেকে কপি)
              </label>
              <label style="cursor: pointer; display: flex; align-items: center; gap: 6px;">
                <input type="checkbox" id="guardian_from_mother" /> Copy Mother's Info (মাতা থেকে কপি)
              </label>
            </div>
            <div class="grid-3">
              <div class="field-group">
                <label>Guardian Name (English) <span class="bn">ইংরেজি নাম</span></label>
                <input type="text" id="guardian_name_en" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Guardian Name (Bangla) <span class="bn">বাংলা নাম</span></label>
                <input type="text" id="guardian_name_bn" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Guardian NID <span class="bn">এনআইডি নম্বর</span></label>
                <input type="text" id="guardian_nid" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Guardian Mobile <span class="bn">মোবাইল নম্বর</span></label>
                <input type="text" id="guardian_mobile" class="input-premium" placeholder="8801xxxxxxxxx" required />
              </div>

              <div class="field-group">
                <label>Guardian Occupation <span class="bn">পেশা</span></label>
                <input type="text" id="guardian_occupation" class="input-premium" required />
              </div>
            </div>
          </div>

          <!-- Section 6: Board / Registration -->
          <div class="card-premium">
            <h2 class="card-title">
              🎓 Board Information <span class="bn">বোর্ড তথ্য</span>
            </h2>
            <div class="grid-3">
              <div class="field-group">
                <label>Board Name <span class="bn">বোর্ডের নাম</span></label>
                <select id="board_name" class="input-premium">
                  <option value="">--Select--</option>
                  <option value="COMILLA">COMILLA</option>
                  <option value="DHAKA">DHAKA</option>
                  <option value="RAJSHAHI">RAJSHAHI</option>
                  <option value="JESSORE">JESSORE</option>
                  <option value="CHITTAGONG">CHITTAGONG</option>
                  <option value="BARISAL">BARISAL</option>
                  <option value="SYLHET">SYLHET</option>
                  <option value="DINAJPUR">DINAJPUR</option>
                  <option value="MADRASAH">MADRASAH</option>
                </select>
              </div>

              <div class="field-group">
                <label>Board Roll <span class="bn">বোর্ড রোল</span></label>
                <input type="text" id="board_roll" class="input-premium" placeholder="Enter board roll" />
              </div>

              <div class="field-group">
                <label>Board Registration <span class="bn">বোর্ড রেজিস্ট্রেশন</span></label>
                <input type="text" id="board_registration" class="input-premium" placeholder="Enter registration number" />
              </div>

              <div class="field-group">
                <label>Birth Certificate URL <span class="bn">জন্ম সনদের ফাইল (URL)</span></label>
                <div class="upload-wrap">
                  <input type="text" id="birth_certificate_url" class="input-premium" placeholder="Birth certificate image URL" />
                  <button type="button" class="btn-upload-trigger file-url-up" data-field="birth_certificate_url">UP</button>
                  <input type="file" class="hidden-file-input" style="display:none;" data-field="birth_certificate_url" accept="image/*,application/pdf" />
                </div>
              </div>

              <div class="field-group">
                <label>Registration Card URL <span class="bn">রেজিস্ট্রেশন কার্ড (URL)</span></label>
                <div class="upload-wrap">
                  <input type="text" id="registration_card_url" class="input-premium" placeholder="Registration card URL" />
                  <button type="button" class="btn-upload-trigger file-url-up" data-field="registration_card_url">UP</button>
                  <input type="file" class="hidden-file-input" style="display:none;" data-field="registration_card_url" accept="image/*,application/pdf" />
                </div>
              </div>

              <div class="field-group">
                <label>Quote Freedom Fighter <span class="bn">মুক্তিযোদ্ধা কোটা</span></label>
                <select id="quote_freedomfighter" class="input-premium" required>
                  <option value="NO">NO</option>
                  <option value="YES">YES</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Section 7: Address Information -->
          <div class="card-premium">
            <h2 class="card-title">
              📍 Address Information <span class="bn">ঠিকানার বিবরণ</span>
            </h2>
            <div class="grid-3">
              <div class="field-group">
                <label>District (English) <span class="bn">জেলা (ইংরেজি)</span></label>
                <select id="district_en" class="input-premium" required>
                  <option value="">Select</option>
                </select>
              </div>

              <div class="field-group">
                <label>District (Bangla) <span class="bn">জেলা (বাংলা)</span></label>
                <select id="district_bn" class="input-premium" required>
                  <option value="">Select</option>
                </select>
              </div>

              <div class="field-group">
                <label>Upazila (English) <span class="bn">উপজেলা (ইংরেজি)</span></label>
                <select id="upazilla_en" class="input-premium" required>
                  <option value="">Select</option>
                </select>
              </div>

              <div class="field-group">
                <label>Upazila (Bangla) <span class="bn">উপজেলা (বাংলা)</span></label>
                <select id="upazilla_bn" class="input-premium" required>
                  <option value="">Select</option>
                </select>
              </div>

              <div class="field-group">
                <label>Union (English) <span class="bn">ইউনিয়ন (ইংরেজি)</span></label>
                <select id="union_en" class="input-premium" required>
                  <option value="">Select</option>
                </select>
              </div>

              <div class="field-group">
                <label>Union (Bangla) <span class="bn">ইউনিয়ন (বাংলা)</span></label>
                <select id="union_bn" class="input-premium" required>
                  <option value="">Select</option>
                </select>
              </div>

              <div class="field-group">
                <label>Village (English) <span class="bn">গ্রাম (ইংরেজি)</span></label>
                <input type="text" id="village_en" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Village (Bangla) <span class="bn">গ্রাম (বাংলা)</span></label>
                <input type="text" id="village_bn" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Post Office (English) <span class="bn">পোস্ট অফিস (ইংরেজি)</span></label>
                <input type="text" id="postoffice_en" class="input-premium" required />
              </div>

              <div class="field-group">
                <label>Post Office (Bangla) <span class="bn">পোস্ট অফিস (বাংলা)</span></label>
                <input type="text" id="postoffice_bn" class="input-premium" required />
              </div>
            </div>
          </div>

          <!-- Section 8: Previous School & Academic History -->
          <div class="card-premium">
            <h2 class="card-title">
              📂 Previous School Information <span class="bn">পূর্ববর্তী স্কুলের তথ্য</span>
            </h2>
            <div class="grid-3">
              <div class="field-group">
                <label>Previous School Name <span class="bn">পূর্ববর্তী স্কুলের নাম</span></label>
                <input type="text" id="previous_school" class="input-premium" placeholder="Enter previous school" />
              </div>

              <div class="field-group">
                <label>Previous Class Roll <span class="bn">পূর্ববর্তী রোল</span></label>
                <input type="text" id="previous_class_roll" class="input-premium" placeholder="Enter previous class roll" />
              </div>

              <div class="field-group">
                <label>Comment (School) <span class="bn">মন্তব্য</span></label>
                <input type="text" id="comment_school" class="input-premium" placeholder="Comments..." />
              </div>
            </div>

            <h3 style="font-size: 13px; font-weight: 700; color: #0f172a; margin-top: 20px; margin-bottom: 12px; border-bottom: 1px dashed rgba(255,255,255,0.06); padding-bottom: 6px;">Academic History (বিগত শিক্ষাবর্ষের তথ্য)</h3>
            <div class="grid-3">
              <div class="field-group">
                <label>Class 2024 <span class="bn">২০২৪ শ্রেণি</span></label>
                <input type="number" id="class_2024" class="input-premium" placeholder="e.g. 5" />
              </div>
              <div class="field-group">
                <label>Section 2024 <span class="bn">২০২৪ শাখা</span></label>
                <input type="text" id="section_2024" class="input-premium" placeholder="e.g. DAY" />
              </div>
              <div class="field-group">
                <label>Roll 2024 <span class="bn">২০২৪ রোল</span></label>
                <input type="number" id="roll_2024" class="input-premium" placeholder="e.g. 1" />
              </div>

              <div class="field-group">
                <label>Class 2025 <span class="bn">২০২৫ শ্রেণি</span></label>
                <input type="number" id="class_2025" class="input-premium" placeholder="e.g. 6" />
              </div>
              <div class="field-group">
                <label>Section 2025 <span class="bn">২০২৫ শাখা</span></label>
                <input type="text" id="section_2025" class="input-premium" placeholder="e.g. DAY" />
              </div>
              <div class="field-group">
                <label>Roll 2025 <span class="bn">২০২৫ রোল</span></label>
                <input type="number" id="roll_2025" class="input-premium" placeholder="e.g. 1" />
              </div>
            </div>
          </div>

          <!-- Submit Buttons -->
          <div class="footer-actions">
            <button type="button" id="resetBtn" class="btn-action secondary">Reset Form</button>
            <button type="submit" id="saveBtn" class="btn-action primary">Submit & Download Receipt</button>
          </div>
        </form>
      </div>
    </div>

    <!-- Canvas Crop Modal Overlay -->
    <div id="cropModal" class="crop-modal-premium">
      <div class="crop-card-premium">
        <h3 style="margin-top:0; color:#fff; font-size:16px; margin-bottom:14px;">Crop Student Image (944 x 1181)</h3>
        <canvas id="cropCanvas" class="crop-canvas-premium"></canvas>
        <div class="crop-actions-premium">
          <button type="button" id="cancelCropBtn" class="crop-btn-premium cancel">Cancel</button>
          <button type="button" id="resetCropBtn" class="crop-btn-premium cancel" style="margin-right:auto;">Reset Selection</button>
          <button type="button" id="confirmCropBtn" class="crop-btn-premium confirm">Crop & Upload</button>
        </div>
      </div>
    </div>
  `;

  // UI elements
  const backBtn = document.getElementById('backBtn')!;
  const resetBtn = document.getElementById('resetBtn')!;
  const saveBtn = document.getElementById('saveBtn') as HTMLButtonElement;
  const alertBox = document.getElementById('alertBox')!;
  const searchBirthReg = document.getElementById('searchBirthReg') as HTMLInputElement;
  const searchBtn = document.getElementById('searchBtn')!;
  
  const guardianFromFather = document.getElementById('guardian_from_father') as HTMLInputElement;
  const guardianFromMother = document.getElementById('guardian_from_mother') as HTMLInputElement;

  const photoPlaceholder = document.getElementById('photoPlaceholder')!;
  const studentPhotoPreview = document.getElementById('studentPhotoPreview') as HTMLImageElement;
  const uploadPhotoBtn = document.getElementById('uploadPhotoBtn')!;
  const studentPhotoFileInput = document.getElementById('student_photo_file') as HTMLInputElement;
  const studentPhotoUrl = document.getElementById('student_photo_url') as HTMLInputElement;

  const cropModal = document.getElementById('cropModal')!;
  const cropCanvas = document.getElementById('cropCanvas') as HTMLCanvasElement;
  const cancelCropBtn = document.getElementById('cancelCropBtn')!;
  const resetCropBtn = document.getElementById('resetCropBtn')!;
  const confirmCropBtn = document.getElementById('confirmCropBtn') as HTMLButtonElement;

  let originalImage: HTMLImageElement | null = null;
  let cropSelection = { x: 0, y: 0, width: 0, height: 0 };
  let isDragging = false;
  let startX = 0;
  let startY = 0;

  function showAlert(msg: string, type: 'success' | 'error' = 'error') {
    alertBox.textContent = msg;
    alertBox.className = 'alert-box-premium ' + type;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  function clearAlert() {
    alertBox.style.display = 'none';
    alertBox.textContent = '';
  }

  // Navigation back
  backBtn.onclick = () => {
    window.location.href = '/other_school_dashboard';
  };

  // Receipt Search portal lookup
  searchBtn.onclick = doReceiptSearch;
  searchBirthReg.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      doReceiptSearch();
    }
  });

  function doReceiptSearch() {
    const br = searchBirthReg.value.trim();
    if (!br) {
      showAlert('Please enter a birth registration number');
      return;
    }
    window.location.href = `/other_school/download_form?birth_reg=${encodeURIComponent(br)}`;
  }

  // Set default current date
  const dateInp = document.getElementById('admission_date') as HTMLInputElement;
  const todayStr = new Date().toISOString().split('T')[0];
  dateInp.value = todayStr;

  // Auto Title Case formatting on specific fields
  const capIds = [
    'student_name_en', 'father_name_en', 'father_occupation',
    'mother_name_en', 'mother_occupation', 'guardian_name_en',
    'guardian_occupation', 'village_en', 'postoffice_en', 'previous_school'
  ];
  function toTitleCase(s: string) {
    return s.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase());
  }
  capIds.forEach(id => {
    const el = document.getElementById(id) as HTMLInputElement | null;
    if (el) {
      el.addEventListener('input', () => {
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const newVal = toTitleCase(el.value);
        if (newVal !== el.value) {
          el.value = newVal;
          try { el.setSelectionRange(start, end); } catch (e) {}
        }
      });
    }
  });

  // Sync section morning vs day with gender
  const sectionSel = document.getElementById('section_2026') as HTMLSelectElement;
  const genderSel = document.getElementById('student_gender') as HTMLSelectElement;
  sectionSel.addEventListener('change', () => {
    const s = sectionSel.value.toUpperCase();
    if (s === 'DAY') {
      genderSel.value = 'MALE';
    } else if (s === 'MORNING') {
      genderSel.value = 'FEMALE';
    }
  });

  // Mobile number validation and 880 prefix security
  const mobFields = ['father_mobile', 'mother_mobile', 'guardian_mobile'];
  mobFields.forEach(id => {
    const f = document.getElementById(id) as HTMLInputElement | null;
    if (!f) return;

    f.addEventListener('focus', () => {
      if (!f.value || f.value.length < 3) f.value = '880';
    });
    f.addEventListener('click', () => {
      if (f.selectionStart !== null && f.selectionStart < 3) {
        f.setSelectionRange(3, 3);
      }
    });
    f.addEventListener('keydown', (e) => {
      if ((e.key === 'Backspace' || e.key === 'Delete') && f.selectionStart !== null && f.selectionStart <= 3) {
        e.preventDefault();
        f.setSelectionRange(3, 3);
      }
    });
    f.addEventListener('input', () => {
      let val = f.value;
      if (!val.startsWith('880')) {
        f.value = '880';
        return;
      }
      // strip non digits
      const digits = val.substring(3).replace(/\D/g, '');
      f.value = '880' + digits;
      if (f.value.length > 14) f.value = f.value.substring(0, 14);
    });
  });

  // Guardian copying
  function getVal(id: string) {
    return (document.getElementById(id) as HTMLInputElement).value.trim();
  }
  function setVal(id: string, v: string) {
    (document.getElementById(id) as HTMLInputElement).value = v || '';
  }
  guardianFromFather.onchange = () => {
    if (guardianFromFather.checked) {
      setVal('guardian_name_en', getVal('father_name_en'));
      setVal('guardian_name_bn', getVal('father_name_bn'));
      setVal('guardian_nid', getVal('father_nid'));
      setVal('guardian_mobile', getVal('father_mobile'));
      setVal('guardian_occupation', getVal('father_occupation'));
      guardianFromMother.checked = false;
    }
  };
  guardianFromMother.onchange = () => {
    if (guardianFromMother.checked) {
      setVal('guardian_name_en', getVal('mother_name_en'));
      setVal('guardian_name_bn', getVal('mother_name_bn'));
      setVal('guardian_nid', getVal('mother_nid'));
      setVal('guardian_mobile', getVal('mother_mobile'));
      setVal('guardian_occupation', getVal('mother_occupation'));
      guardianFromFather.checked = false;
    }
  };

  // ImgBB Upload helper for PDF files
  const fileUrlButtons = document.querySelectorAll('.file-url-up');
  fileUrlButtons.forEach((btn: any) => {
    btn.onclick = () => {
      const field = btn.dataset.field;
      const fileInp = document.querySelector(`.hidden-file-input[data-field="${field}"]`) as HTMLInputElement;
      if (fileInp) fileInp.click();
    };
  });
  const fileInputs = document.querySelectorAll('.hidden-file-input');
  fileInputs.forEach((inp: any) => {
    inp.onchange = async () => {
      const file = inp.files[0];
      if (!file) return;
      const field = inp.dataset.field;
      const btn = document.querySelector(`.file-url-up[data-field="${field}"]`) as HTMLButtonElement;
      const textInp = document.getElementById(field) as HTMLInputElement;

      btn.textContent = '...';
      btn.disabled = true;
      try {
        const formData = new FormData();
        formData.append('image', file);
        const res = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
          method: 'POST',
          body: formData
        });
        if (!res.ok) throw new Error('ImgBB Upload failed');
        const data = await res.json();
        if (!data.success) throw new Error(data.error?.message || 'Upload failed');
        textInp.value = data.data.url;
        btn.textContent = 'OK';
        btn.classList.add('uploaded');
      } catch (err: any) {
        alert(err.message);
        btn.textContent = 'ERR';
      } finally {
        btn.disabled = false;
      }
    };
  });

  // Photo Cropper handlers
  uploadPhotoBtn.onclick = () => studentPhotoFileInput.click();
  photoPlaceholder.onclick = () => studentPhotoFileInput.click();

  studentPhotoFileInput.onchange = () => {
    const file = studentPhotoFileInput.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const img = new Image();
      img.onload = () => {
        originalImage = img;
        setupCropCanvas();
        cropModal.classList.add('active');
      };
      img.src = e.target?.result as string;
    };
    reader.readAsDataURL(file);
  };

  cancelCropBtn.onclick = () => {
    cropModal.classList.remove('active');
    studentPhotoFileInput.value = '';
    originalImage = null;
  };

  resetCropBtn.onclick = () => {
    if (cropCanvas) resetCrop();
  };

  confirmCropBtn.onclick = async () => {
    if (!originalImage || cropSelection.width === 0) {
      alert('Please select a cropping selection region.');
      return;
    }

    confirmCropBtn.disabled = true;
    confirmCropBtn.textContent = 'Uploading...';
    try {
      const croppedCanvas = document.createElement('canvas');
      const croppedCtx = croppedCanvas.getContext('2d')!;

      // Target size
      const targetW = 944;
      const targetH = 1181;
      croppedCanvas.width = targetW;
      croppedCanvas.height = targetH;

      const scaleX = originalImage.width / cropCanvas.width;
      const scaleY = originalImage.height / cropCanvas.height;

      croppedCtx.drawImage(
        originalImage,
        cropSelection.x * scaleX,
        cropSelection.y * scaleY,
        cropSelection.width * scaleX,
        cropSelection.height * scaleY,
        0, 0, targetW, targetH
      );

      const blob = await new Promise<Blob | null>(res => croppedCanvas.toBlob(res, 'image/jpeg', 0.95));
      if (!blob) throw new Error('Failed to generate image blob');

      const formData = new FormData();
      formData.append('image', blob);
      const res = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
        method: 'POST',
        body: formData
      });
      if (!res.ok) throw new Error('ImgBB photo upload failed');
      const resJson = await res.json();
      if (!resJson.success) throw new Error(resJson.error?.message || 'Upload failed');

      const url = resJson.data.url;
      studentPhotoUrl.value = url;
      studentPhotoPreview.src = url;
      studentPhotoPreview.style.display = 'block';
      photoPlaceholder.style.display = 'none';
      uploadPhotoBtn.classList.add('uploaded');
      uploadPhotoBtn.textContent = 'Change Photo';
      cropModal.classList.remove('active');
    } catch (err: any) {
      alert('Photo processing failed: ' + err.message);
    } finally {
      confirmCropBtn.disabled = false;
      confirmCropBtn.textContent = 'Crop & Upload';
    }
  };

  function setupCropCanvas() {
    if (!originalImage) return;
    const ctx = cropCanvas.getContext('2d')!;
    const maxW = 600;
    const maxH = 400;

    let canvasW = originalImage.width;
    let canvasH = originalImage.height;

    if (canvasW > maxW) {
      canvasH = (canvasH * maxW) / canvasW;
      canvasW = maxW;
    }
    if (canvasH > maxH) {
      canvasW = (canvasW * maxH) / canvasH;
      canvasH = maxH;
    }

    cropCanvas.width = canvasW;
    cropCanvas.height = canvasH;

    ctx.drawImage(originalImage, 0, 0, canvasW, canvasH);

    const aspect = 944 / 1181;
    let cropW: number, cropH: number;
    if (canvasW / canvasH > aspect) {
      cropH = canvasH * 0.8;
      cropW = cropH * aspect;
    } else {
      cropW = canvasW * 0.8;
      cropH = cropW / aspect;
    }

    cropSelection = {
      x: (canvasW - cropW) / 2,
      y: (canvasH - cropH) / 2,
      width: cropW,
      height: cropH
    };

    drawCropOverlay();

    cropCanvas.onmousedown = (e) => {
      const rect = cropCanvas.getBoundingClientRect();
      startX = e.clientX - rect.left;
      startY = e.clientY - rect.top;
      isDragging = true;
    };
    cropCanvas.onmousemove = (e) => {
      if (!isDragging) return;
      const rect = cropCanvas.getBoundingClientRect();
      const currX = e.clientX - rect.left;
      const currY = e.clientY - rect.top;

      const w = Math.abs(currX - startX);
      const h = Math.abs(currY - startY);
      const aspect = 944 / 1181;

      let cropW: number, cropH: number;
      if (w / h > aspect) {
        cropH = h;
        cropW = cropH * aspect;
      } else {
        cropW = w;
        cropH = cropW / aspect;
      }

      cropSelection.x = Math.min(startX, currX);
      cropSelection.y = Math.min(startY, currY);
      cropSelection.width = cropW;
      cropSelection.height = cropH;

      if (cropSelection.x + cropSelection.width > cropCanvas.width) {
        cropSelection.width = cropCanvas.width - cropSelection.x;
        cropSelection.height = cropSelection.width / aspect;
      }
      if (cropSelection.y + cropSelection.height > cropCanvas.height) {
        cropSelection.height = cropCanvas.height - cropSelection.y;
        cropSelection.width = cropSelection.height * aspect;
      }

      drawCropOverlay();
    };
    cropCanvas.onmouseup = () => isDragging = false;
    cropCanvas.onmouseleave = () => isDragging = false;
  }

  function drawCropOverlay() {
    if (!originalImage) return;
    const ctx = cropCanvas.getContext('2d')!;
    ctx.clearRect(0, 0, cropCanvas.width, cropCanvas.height);
    ctx.drawImage(originalImage, 0, 0, cropCanvas.width, cropCanvas.height);

    ctx.fillStyle = 'rgba(0, 0, 0, 0.5)';
    ctx.fillRect(0, 0, cropCanvas.width, cropCanvas.height);

    ctx.clearRect(cropSelection.x, cropSelection.y, cropSelection.width, cropSelection.height);
    ctx.drawImage(
      originalImage,
      (cropSelection.x / cropCanvas.width) * originalImage.width,
      (cropSelection.y / cropCanvas.height) * originalImage.height,
      (cropSelection.width / cropCanvas.width) * originalImage.width,
      (cropSelection.height / cropCanvas.height) * originalImage.height,
      cropSelection.x, cropSelection.y, cropSelection.width, cropSelection.height
    );

    ctx.strokeStyle = '#10b981';
    ctx.lineWidth = 2;
    ctx.strokeRect(cropSelection.x, cropSelection.y, cropSelection.width, cropSelection.height);
  }

  function resetCrop() {
    if (!cropCanvas) return;
    const aspect = 944 / 1181;
    let cropW: number, cropH: number;
    if (cropCanvas.width / cropCanvas.height > aspect) {
      cropH = cropCanvas.height * 0.8;
      cropW = cropH * aspect;
    } else {
      cropW = cropCanvas.width * 0.8;
      cropH = cropW / aspect;
    }
    cropSelection = {
      x: (cropCanvas.width - cropW) / 2,
      y: (cropCanvas.height - cropH) / 2,
      width: cropW,
      height: cropH
    };
    drawCropOverlay();
  }

  // Cascading Address CSV loaders
  let addressData: any[] = [];
  async function loadAddressCSV() {
    try {
      const res = await fetch('/src/address_info.csv');
      if (!res.ok) throw new Error('Address CSV not found');
      const text = await res.text();
      const lines = text.split('\n').filter(line => line.trim());
      const headers = lines[0].split(',').map(h => h.trim());
      addressData = lines.slice(1).map(line => {
        const cols = line.split(',');
        const obj: any = {};
        headers.forEach((h, idx) => {
          obj[h] = cols[idx]?.trim() || '';
        });
        return obj;
      });
      populateAddressDropdowns();
    } catch (e) {
      console.warn('Failed to load address CSV, using default options', e);
    }
  }

  function populateAddressDropdowns() {
    const distEn = document.getElementById('district_en') as HTMLSelectElement;
    const distBn = document.getElementById('district_bn') as HTMLSelectElement;
    const upzEn = document.getElementById('upazilla_en') as HTMLSelectElement;
    const upzBn = document.getElementById('upazilla_bn') as HTMLSelectElement;
    const uniEn = document.getElementById('union_en') as HTMLSelectElement;
    const uniBn = document.getElementById('union_bn') as HTMLSelectElement;

    if (!distEn || !distBn) return;

    // Fetch unique districts
    const distPair = [...new Set(addressData.map(row => `${row.district_en}|${row.district_bn}`))].sort();
    distEn.innerHTML = '<option value="">Select District</option>' + distPair.map(p => `<option value="${p.split('|')[0]}">${p.split('|')[0]}</option>`).join('');
    distBn.innerHTML = '<option value="">জেলা সিলেক্ট করুন</option>' + distPair.map(p => `<option value="${p.split('|')[0]}">${p.split('|')[1]}</option>`).join('');

    let _syncing = false;
    distEn.onchange = () => {
      if (_syncing) return;
      _syncing = true;
      distBn.selectedIndex = distEn.selectedIndex;
      _syncing = false;
      updateUpazilas(distEn.value);
    };
    distBn.onchange = () => {
      if (_syncing) return;
      _syncing = true;
      distEn.selectedIndex = distBn.selectedIndex;
      _syncing = false;
      updateUpazilas(distEn.value);
    };

    function updateUpazilas(dEn: string) {
      [upzEn, upzBn, uniEn, uniBn].forEach(s => {
        s.innerHTML = '<option value="">Select</option>';
      });
      if (!dEn) return;

      const upPairs = [...new Set(addressData.filter(row => row.district_en === dEn).map(row => `${row.upazila_en}|${row.upazila_bn}`))].sort();
      upzEn.innerHTML = '<option value="">Select Upazila</option>' + upPairs.map(p => `<option value="${p.split('|')[0]}">${p.split('|')[0]}</option>`).join('');
      upzBn.innerHTML = '<option value="">উপজেলা সিলেক্ট করুন</option>' + upPairs.map(p => `<option value="${p.split('|')[0]}">${p.split('|')[1]}</option>`).join('');
    }

    let _upSync = false;
    upzEn.onchange = () => {
      if (_upSync) return;
      _upSync = true;
      upzBn.selectedIndex = upzEn.selectedIndex;
      _upSync = false;
      updateUnions(upzEn.value);
    };
    upzBn.onchange = () => {
      if (_upSync) return;
      _upSync = true;
      upzEn.selectedIndex = upzBn.selectedIndex;
      _upSync = false;
      updateUnions(upzEn.value);
    };

    function updateUnions(upEnName: string) {
      [uniEn, uniBn].forEach(s => {
        s.innerHTML = '<option value="">Select</option>';
      });
      if (!upEnName) return;

      const unPairs = [...new Set(addressData.filter(row => row.upazila_en === upEnName).map(row => `${row.union_en}|${row.union_bn}`))].sort();
      
      // Add Pourashava manually if not present
      if (!unPairs.some(p => p.startsWith('POURASHAVA'))) {
        unPairs.push('POURASHAVA|পৌরসভা');
      }

      uniEn.innerHTML = '<option value="">Select Union</option>' + unPairs.map(p => `<option value="${p.split('|')[0]}">${p.split('|')[0]}</option>`).join('');
      uniBn.innerHTML = '<option value="">ইউনিয়ন সিলেক্ট করুন</option>' + unPairs.map(p => `<option value="${p.split('|')[0]}">${p.split('|')[1]}</option>`).join('');
    }

    let _uniSync = false;
    uniEn.onchange = () => {
      if (_uniSync) return;
      _uniSync = true;
      uniBn.selectedIndex = uniEn.selectedIndex;
      _uniSync = false;
    };
    uniBn.onchange = () => {
      if (_uniSync) return;
      _uniSync = true;
      uniEn.selectedIndex = uniBn.selectedIndex;
      _uniSync = false;
    };
  }

  await loadAddressCSV();

  // Validate form required values
  function validateAll(): boolean {
    clearAlert();
    const reqs = Array.from(document.querySelectorAll('input[required], select[required]')) as (HTMLInputElement | HTMLSelectElement)[];
    const invalidList: (HTMLInputElement | HTMLSelectElement)[] = [];

    reqs.forEach(el => {
      const v = el.value.trim();
      if (!v) {
        el.classList.add('invalid');
        invalidList.push(el);
      } else {
        el.classList.remove('invalid');
      }
    });

    if (invalidList.length > 0) {
      const first = invalidList[0];
      const parentGrp = first.closest('.field-group');
      let lblText = first.id;
      if (parentGrp) {
        const lbl = parentGrp.querySelector('label');
        if (lbl) lblText = lbl.textContent?.replace(/\*|\(.*?\)/g, '').trim() || first.id;
      }
      showAlert(`Please fill in the required field: ${lblText}`, 'error');
      first.focus();
      return false;
    }

    return true;
  }

  // Clear invalid outline when typed
  document.addEventListener('input', (e) => {
    const t = e.target as HTMLElement;
    if (t && (t.tagName === 'INPUT' || t.tagName === 'SELECT')) {
      t.classList.remove('invalid');
    }
  });

  // Submit Logic
  const form = document.getElementById('admissionForm') as HTMLFormElement;
  form.onsubmit = async (e) => {
    e.preventDefault();
    if (!validateAll()) return;

    saveBtn.disabled = true;
    saveBtn.textContent = 'Submitting...';

    // Helper formatting functions
    const upper = (s: string | null) => s ? s.trim().toUpperCase() : null;
    const toNumber = (s: string) => {
      const n = parseInt(s, 10);
      return isNaN(n) ? null : n;
    };
    const getSelText = (id: string) => {
      const el = document.getElementById(id) as HTMLSelectElement | null;
      if (!el || !el.value) return null;
      return el.options[el.selectedIndex].text.trim();
    };

    const payload = {
      session: toNumber(getVal('session')),
      class_2026: toNumber(getVal('class_2026')),
      section_2026: upper(getVal('section_2026')),
      roll_2026: toNumber(getVal('roll_2026')),
      admission_date: getVal('admission_date') || null,
      school_name_others: upper(getVal('school_name_others')),
      group: upper(getVal('group')),
      optional_subject: upper(getVal('optional_subject')),

      student_name_en: upper(getVal('student_name_en')),
      student_name_bn: getVal('student_name_bn') || null,
      birth_registration: upper(getVal('birth_registration')),
      student_dateofbirth: getVal('student_dateofbirth') || null,
      religion: upper(getVal('religion')),
      student_gender: upper(getVal('student_gender')),
      student_blood_group: upper(getVal('student_blood_group')),
      student_photo_url: getVal('student_photo_url') || null,

      father_name_en: upper(getVal('father_name_en')),
      father_name_bn: getVal('father_name_bn') || null,
      father_nid: upper(getVal('father_nid')),
      father_mobile: getVal('father_mobile') || null,
      father_occupation: upper(getVal('father_occupation')),
      father_dob: getVal('father_dob') || null,
      father_blood_group: upper(getVal('father_blood_group')),

      mother_name_en: upper(getVal('mother_name_en')),
      mother_name_bn: getVal('mother_name_bn') || null,
      mother_nid: upper(getVal('mother_nid')),
      mother_mobile: getVal('mother_mobile') || null,
      mother_occupation: upper(getVal('mother_occupation')),
      mother_dob: getVal('mother_dob') || null,
      mother_blood_group: upper(getVal('mother_blood_group')),

      guardian_name_en: upper(getVal('guardian_name_en')),
      guardian_name_bn: getVal('guardian_name_bn') || null,
      guardian_nid: upper(getVal('guardian_nid')),
      guardian_mobile: getVal('guardian_mobile') || null,
      guardian_occupation: upper(getVal('guardian_occupation')),

      board_name: upper(getVal('board_name')),
      board_roll: upper(getVal('board_roll')),
      board_registration: upper(getVal('board_registration')),
      birth_certificate_url: getVal('birth_certificate_url') || null,
      registration_card_url: getVal('registration_card_url') || null,
      quote_freedomfighter: upper(getVal('quote_freedomfighter')),

      district_en: upper(getSelText('district_en')),
      district_bn: getSelText('district_bn'),
      upazilla_en: upper(getSelText('upazilla_en')),
      upazilla_bn: getSelText('upazilla_bn'),
      union_en: upper(getSelText('union_en')),
      union_bn: getSelText('union_bn'),
      village_en: upper(getVal('village_en')),
      village_bn: getVal('village_bn') || null,
      postoffice_en: upper(getVal('postoffice_en')),
      postoffice_bn: getVal('postoffice_bn') || null,

      previous_school: upper(getVal('previous_school')),
      previous_class_roll: upper(getVal('previous_class_roll')),
      comment_school: getVal('comment_school') || null,

      class_2024: toNumber(getVal('class_2024')),
      section_2024: upper(getVal('section_2024')),
      roll_2024: toNumber(getVal('roll_2024')),

      class_2025: toNumber(getVal('class_2025')),
      section_2025: upper(getVal('section_2025')),
      roll_2025: toNumber(getVal('roll_2025')),

      input_user_name: (function() {
        try { return localStorage.getItem('adminButton') || null; } catch(e) { return null; }
      })()
    };

    try {
      const { error } = await sb.from(TABLE).insert([payload]);
      if (error) throw error;

      showAlert('Submitted successfully! Generating Receipt PDF...', 'success');

      // Lazy load html2canvas + jsPDF and generate receipt
      await generateAdmissionReceipt(payload);

      // Reset form fields
      form.reset();
      studentPhotoPreview.style.display = 'none';
      photoPlaceholder.style.display = 'flex';
      uploadPhotoBtn.classList.remove('uploaded');
      uploadPhotoBtn.textContent = 'Choose File';
      studentPhotoUrl.value = '';
    } catch (err: any) {
      console.error(err);
      showAlert('Database submission failed: ' + err.message, 'error');
    } finally {
      saveBtn.disabled = false;
      saveBtn.textContent = 'Submit & Download Receipt';
    }
  };

  resetBtn.onclick = () => {
    form.reset();
    clearAlert();
    studentPhotoPreview.style.display = 'none';
    photoPlaceholder.style.display = 'flex';
    uploadPhotoBtn.classList.remove('uploaded');
    uploadPhotoBtn.textContent = 'Choose File';
    studentPhotoUrl.value = '';
  };

  // Pre-load dependencies
  await loadDependencies();
}

// Script and CDN loaders
async function loadScript(url: string): Promise<void> {
  return new Promise((res, rej) => {
    if (document.querySelector(`script[src="${url}"]`)) {
      res();
      return;
    }
    const script = document.createElement('script');
    script.src = url;
    script.onload = () => res();
    script.onerror = () => rej(new Error('CDN Load fail: ' + url));
    document.head.appendChild(script);
  });
}

async function loadDependencies() {
  try {
    await loadScript('https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js');
    await loadScript('https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js');
  } catch (e) {
    console.warn('CDN Preload failed', e);
  }
}

// Receipt printable format template renderer
function renderPdfReceiptMarkup(o: any) {
  const fieldsGroup = [
    {
      title: 'Admission Scope',
      fields: [
        ['Session', o.session], ['School Name (Others)', o.school_name_others], ['Admission Class', o.class_2026], ['Admission Section', o.section_2026], ['Admission Roll', o.roll_2026], ['Admission Date', o.admission_date]
      ]
    },
    {
      title: 'Student Profile',
      fields: [
        ['Student Name (EN)', o.student_name_en], ['Student Name (BN)', o.student_name_bn], ['Birth Registration', o.birth_registration], ['Date of Birth', o.student_dateofbirth], ['Religion', o.religion], ['Gender', o.student_gender], ['Blood Group', o.student_blood_group]
      ]
    },
    {
      title: 'Board / Registration',
      fields: [
        ['Board Name', o.board_name], ['Board Roll', o.board_roll], ['Board Registration', o.board_registration], ['Academic Group', o.group], ['Optional Subject', o.optional_subject]
      ]
    },
    {
      title: 'Father details',
      fields: [
        ['Father Name (EN)', o.father_name_en], ['Father Name (BN)', o.father_name_bn], ['Father NID', o.father_nid], ['Father Mobile', o.father_mobile], ['Father Occupation', o.father_occupation], ['Father Date of Birth', o.father_dob], ['Father Blood Group', o.father_blood_group]
      ]
    },
    {
      title: 'Mother details',
      fields: [
        ['Mother Name (EN)', o.mother_name_en], ['Mother Name (BN)', o.mother_name_bn], ['Mother NID', o.mother_nid], ['Mother Mobile', o.mother_mobile], ['Mother Occupation', o.mother_occupation], ['Mother Date of Birth', o.mother_dob], ['Mother Blood Group', o.mother_blood_group]
      ]
    },
    {
      title: 'Guardian details',
      fields: [
        ['Guardian Name (EN)', o.guardian_name_en], ['Guardian Name (BN)', o.guardian_name_bn], ['Guardian NID', o.guardian_nid], ['Guardian Mobile', o.guardian_mobile], ['Guardian Occupation', o.guardian_occupation]
      ]
    },
    {
      title: 'Address Information',
      fields: [
        ['District (EN)', o.district_en], ['District (BN)', o.district_bn], ['Upazila (EN)', o.upazilla_en], ['Upazila (BN)', o.upazilla_bn], ['Union (EN)', o.union_en], ['Union (BN)', o.union_bn], ['Post Office (EN)', o.postoffice_en], ['Post Office (BN)', o.postoffice_bn], ['Village (EN)', o.village_en], ['Village (BN)', o.village_bn]
      ]
    },
    {
      title: 'Academic History',
      fields: [
        ['Class 2024', o.class_2024], ['Section 2024', o.section_2024], ['Roll 2024', o.roll_2024], ['Class 2025', o.class_2025], ['Section 2025', o.section_2025], ['Roll 2025', o.roll_2025]
      ]
    },
    {
      title: 'Additional Info',
      fields: [
        ['Previous School', o.previous_school], ['Previous Class Roll', o.previous_class_roll], ['School Comment', o.comment_school], ['Freedom Fighter Quote', o.quote_freedomfighter]
      ]
    }
  ];

  function getField(label: string, v: any) {
    const val = (v === null || v === undefined) ? '—' : String(v);
    return `<div class="f"><span class="l">${label}</span><span class="v">${escapeHtml(val)}</span></div>`;
  }

  const groupsHtml = fieldsGroup.map(g => {
    const half = Math.ceil(g.fields.length / 2);
    const left = g.fields.slice(0, half).map(([lbl, val]) => getField(lbl, val)).join('');
    const right = g.fields.slice(half).map(([lbl, val]) => getField(lbl, val)).join('');
    return `
      <div class="group-sect">
        <h3>📄 ${escapeHtml(g.title)}</h3>
        <div class="two-cols">
          <div class="col">${left}</div>
          <div class="col">${right}</div>
        </div>
      </div>
    `;
  }).join('');

  const photoHtml = o.student_photo_url ?
    `<img src="${escapeHtml(o.student_photo_url)}" alt="Student photo" style="width:100%; height:100%; object-fit:cover;" crossorigin="anonymous"/>` :
    `<div style="width:100%; height:100%; display:flex; align-items:center; justify-content:center; font-size:10px; color:#94a3b8;">No Image</div>`;

  return `
    <div id="receiptTemplate" class="receipt-sheet">
      <div class="receipt-header">
        <div class="logo-box">
          <img src="https://i.ibb.co.com/fVQYbqCv/2ba607df-a5e3-4ff2-89d9-70a30871d946.png" alt="School Logo" crossorigin="anonymous" />
        </div>
        <div class="photo-box">${photoHtml}</div>
        <div class="school-title">Feni Model High School</div>
        <div class="school-subtitle">Admission Form Receipt (${o.session || ''})</div>
        <div class="receipt-meta">Birth Registration: <strong>${escapeHtml(o.birth_registration || '')}</strong></div>
      </div>
      ${groupsHtml}
      <div class="receipt-sign-row">
        <div>Guardian's Signature: __________________</div>
        <div>Student's Signature: __________________</div>
        <div>Date: _____________</div>
      </div>
    </div>
  `;
}

// Generate receipt PDF download
async function generateAdmissionReceipt(payload: any) {
  const container = document.createElement('div');
  container.id = 'receiptTempContainer';
  container.innerHTML = renderPdfReceiptMarkup(payload);

  const style = document.createElement('style');
  style.textContent = `
    #receiptTempContainer { position: fixed; top: -9999px; left: 0; z-index: -1; }
    .receipt-sheet {
      box-sizing: border-box;
      width: 210mm;
      background: #fffcf0; /* beautiful light yellow tint backplate */
      padding: 14mm 12mm;
      border-radius: 4px;
      font-family: 'Outfit', 'Segoe UI', sans-serif;
      color: #0b1220;
    }
    .receipt-header {
      position: relative;
      text-align: center;
      margin-bottom: 12px;
      border-bottom: 2px solid #dc2626;
      padding-bottom: 10px;
      min-height: 110px;
    }
    .logo-box {
      position: absolute;
      top: 0;
      left: 10px;
      width: 70px;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .logo-box img {
      max-width: 100%;
      max-height: 100%;
      object-fit: contain;
    }
    .photo-box {
      position: absolute;
      top: 0;
      right: 10px;
      width: 90px;
      height: 110px;
      border: 2px solid #dc2626;
      border-radius: 4px;
      overflow: hidden;
      background: #fff;
    }
    .school-title {
      font-size: 20px;
      font-weight: 850;
      color: #92400e;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
    .school-subtitle {
      font-size: 13px;
      font-weight: 700;
      margin-top: 4px;
      color: #6b4226;
    }
    .receipt-meta {
      font-size: 11.5px;
      margin-top: 4px;
      color: #475569;
    }
    .group-sect {
      margin-bottom: 10px;
      border-bottom: 1px dashed rgba(146, 64, 14, 0.15);
      padding-bottom: 6px;
    }
    .group-sect h3 {
      font-size: 12.5px;
      margin: 0 0 6px 0;
      color: #92400e;
      font-weight: 800;
      text-transform: uppercase;
      letter-spacing: 0.3px;
    }
    .two-cols {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
    }
    .f {
      display: flex;
      font-size: 10.5px;
      padding: 3px 0;
      border-bottom: 1px dashed #f1f5f9;
      gap: 8px;
    }
    .f:last-child {
      border-bottom: none;
    }
    .f .l {
      flex: 0 0 130px;
      font-weight: 700;
      color: #78350f;
    }
    .f .v {
      flex: 1;
      color: #0f172a;
    }
    .receipt-sign-row {
      display: flex;
      justify-content: space-between;
      font-size: 11px;
      margin-top: 24px;
      color: #0f172a;
    }
  `;

  document.head.appendChild(style);
  document.body.appendChild(container);

  // Wait for photo image to pre-render completely
  await new Promise(resolve => setTimeout(resolve, 1000));

  try {
    const root = document.getElementById('receiptTemplate');
    if (!root) throw new Error('Root template elements missing');

    const html2canvasLib = (window as any).html2canvas;
    const jspdfLib = (window as any).jspdf;

    if (!html2canvasLib || !jspdfLib) throw new Error('Required PDF libraries fail loading');

    const canvas = await html2canvasLib(root, {
      scale: 2,
      useCORS: true,
      backgroundColor: '#fffcf0'
    });

    const imgData = canvas.toDataURL('image/png');
    const pdf = new jspdfLib.jsPDF({
      unit: 'mm',
      format: 'a4',
      orientation: 'portrait'
    });

    const pw = pdf.internal.pageSize.getWidth();
    const ph = pdf.internal.pageSize.getHeight();

    let imgW = pw;
    let imgH = (canvas.height * imgW) / canvas.width;
    let x = 0, y = 0;

    if (imgH > ph) {
      imgH = ph;
      imgW = (canvas.width * imgH) / canvas.height;
      x = (pw - imgW) / 2;
      y = 0;
    } else {
      y = (ph - imgH) / 2;
      x = 0;
    }

    pdf.addImage(imgData, 'JPEG', x, y, imgW, imgH, undefined, 'FAST');
    pdf.save(`receipt_${payload.birth_registration || Date.now()}.pdf`);
  } catch (err: any) {
    console.error('PDF construction failed:', err);
    alert('PDF creation failed: ' + err.message);
  } finally {
    if (container.parentNode) container.parentNode.removeChild(container);
    if (style.parentNode) style.parentNode.removeChild(style);
  }
}
